<div class="card">
  <div class="card-body">
    <div class="mb-56">
      <h4 class="mb-56 d-inline">Add Notification</h4>
      <div class="button-row mb-4 d-inline float-end">
        <button mat-raised-button class="me-8 mb-8" [routerLink]="['../notifications']" color="primary">
          Back to List
        </button>
      </div>
    </div>
    <form [formGroup]="notificationForm" (ngSubmit)="onSubmit()" #myForm="ngForm">
      <!-- Title -->
      <mat-form-field class="w-100 fs-16" appearance="outline">
        <mat-label>Title</mat-label>
        <input matInput type="text" formControlName="title" placeholder="Enter notification title" />
        <mat-error *ngIf="notificationForm.controls['title'].hasError('required') || myForm.submitted">
          Title is required.
        </mat-error>
        <mat-error *ngIf="notificationForm.controls['title'].hasError('minlength') || myForm.submitted">
          Title must be at least 3 characters long.
        </mat-error>
      </mat-form-field>

      <!-- Message -->
      <mat-form-field class="w-100 fs-16" appearance="outline">
        <mat-label>Message</mat-label>
        <textarea matInput formControlName="message" placeholder="Enter notification message" rows="4"></textarea>
        <mat-error *ngIf="notificationForm.controls['message'].hasError('required') || myForm.submitted">
          Message is required.
        </mat-error>
        <mat-error *ngIf="
            notificationForm.controls['message'].hasError('minlength') ||
            myForm.submitted
          ">
          Message must be at least 10 characters long.
        </mat-error>
      </mat-form-field>

      <!-- Image Upload -->
      <div class="mb-3">
        <button type="button" mat-raised-button (click)="fileInput.click()" class="mb-3">
          <mat-icon>upload_file</mat-icon>
          Choose File
        </button>
        <input hidden (change)="onFileSelected($event)" #fileInput accept="image/jpeg,image/jpg,image/png" type="file"
          id="file" formControlName="image" />
        <div class="text-muted mt-2">
          <small>Allowed formats: JPG, JPEG, PNG (Max size: 20MB)</small>
        </div>
      </div>

      <div *ngIf="preview" class="mb-3">
        <img [src]="preview" class="preview" alt="Preview" />
      </div>

      <button [disabled]="notificationForm.errors || notificationForm.invalid || isSubmitting" mat-raised-button
        color="primary" type="submit">
        {{ isSubmitting ? 'Sending...' : 'Send Notification' }}
      </button>
    </form>
  </div>
</div>